import SlimSelect from 'slim-select'

import { toggleBorder } from './toggle-border'


export const customSelect = (el, border) => new SlimSelect({
  select: el,
  showSearch: false,
  afterOpen() {
    toggleBorder(border, 'show')
  },
  afterClose() {
    toggleBorder(border)
  },
})
